import { useCallback, useEffect, useState } from "react";
import { API_TOTALREWARD_SERVICE, restApiRequest } from "src/utils/Api";
import { dynamicNotification } from "src/utils/Notifications";
import __ from "src/utils/Translations";
import newRelicErrorReport from "src/utils/newRelic/newRelicErrorReport";
import { DEFAULT_ITEMS_COUNT_PER_REQUEST } from "src/utils/constants/api";
import { orderBy } from "lodash";

const apiCache = {};

export const getUsersOptionsFetchMethod =
  (
    companyId,
    currValue,
    itemsPerPage = DEFAULT_ITEMS_COUNT_PER_REQUEST,
    timeLimit = 3600000
  ) =>
  async (inputValue = "", page = 1) => {
    const params = {
      tenant: companyId,
      itemsPerPage,
      page,
    };
    if (inputValue) {
      params.firstName = inputValue;
      params.lastName = inputValue;
      params.fk = inputValue;
    } else if (currValue) {
      params.id = currValue;
    }
    let result = [];
    const key = `users|${JSON.stringify(params)}`;
    if (apiCache[key] && apiCache[key].timestamp + timeLimit > Date.now()) {
      result = apiCache[key].data || [];
    } else {
      result = await restApiRequest(
        API_TOTALREWARD_SERVICE,
        "/omb/users",
        "GET",
        {
          params,
        },
        mockData
      );
      apiCache[key] = { data: result, timestamp: Date.now() };
    }
    return orderBy(
      result?.map((c) => ({
        value: c.id,
        label: `${c.lastName} ${c.firstName} (${c.fk || ""})`,
      })) || [],
      "label"
    );
  };

const mockData = [
  {
    fk: "5779",
    id: "004bfa47-dc81-4619-aa18-288d130db14e",
    firstName: "Jan",
    lastName: "Kowalski",
  },
];
